export default __webpack_public_path__ + "static/media/skillsLaunchpadAdvisor2.8e95af1a.png";